import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@components/Typography';
import { dashboardActions } from '@actions';
import { useRecommendationsMap } from './recommendationsMap';

const List = styled('div')({
    marginTop: 16,
    paddingTop: 16,
    borderTop: '1px solid var(--divider)',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
});

const Row = styled('button')({
    display: 'grid',
    gridTemplateColumns: '20px 1fr',
    alignItems: 'center',
    gap: 12,
    padding: '8px',
    border: 'none',
    borderRadius: 8,
    background: 'transparent',
    width: '100%',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'var(--text-primary)',
    font: 'inherit',
    transition: 'background-color 120ms ease',
    '& > svg': {
        color: 'var(--primary-main)',
    },
    '&:hover': {
        backgroundColor: 'var(--background-hover, rgba(31, 76, 92, 0.04))',
    },
});

const WidgetRecommendations = ({ types }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const recommendations = useSelector(state => state.dashboard.recommendations);
    const map = useRecommendationsMap();

    const items = (types || [])
        .map(type => ({
            type,
            rec: recommendations.find(r => r.type === type && !r.isHidden),
        }))
        .filter(({ rec }) => !!rec && +rec.value > 0);

    if (items.length === 0) return null;

    const onClick = type => {
        const config = map[type];
        if (!config) return;
        navigate(config.url);
        dispatch(dashboardActions.updateRecommendation(type, { isActual: false }));
    };

    return (
        <List>
            {items.map(({ type, rec }) => {
                const config = map[type];
                if (!config) return null;
                return (
                    <Row key={type} type="button" onClick={() => onClick(type)}>
                        <InfoOutlinedIcon sx={{ width: 20, height: 20 }} />
                        <Typography variant="body2" sx={{ color: 'var(--text-primary)' }}>
                            {config.title}{' '}
                            <span style={{ color: 'var(--text-secondary)' }}>
                                ({config.chip ? config.chip(+rec.value) : rec.value})
                            </span>
                        </Typography>
                    </Row>
                );
            })}
        </List>
    );
};

export default WidgetRecommendations;
